import MockAdapter from 'axios-mock-adapter';

export default api => {
  const apiMock = new MockAdapter(api, { delayResponse: 500 });

  apiMock.onAny().passThrough();
};
